import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import { takeLatest } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";
import * as constants from "../constants";

export function* handleFetchEnrollmentHistory({ data }) {
  try {
    const response = yield axios.get(`${baseURL}/api/v2/enrolment-history`);

    const { success } = response.data;
    if (success) {
      yield put(
        actions.fetchEnrollmentHistorySuccess(response.data.data.history)
      );
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchEnrollmentHistoryError());
    AntdAlert.error("Something went wrong!");
    console.log(error);
  }
}

export function* watcherEntrollmentHistorySaga() {
  yield takeLatest(
    constants.FETCH_ENROLLMENT_HISTORY,
    handleFetchEnrollmentHistory
  );
}
